"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.between = between;
exports.inverse = inverse;
function between(min, max, val) {
  return Math.min(max, Math.max(min, val));
}

function inverse(val) {
  return val * -1;
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-math/lib/index.js
// module id = 1564
// module chunks = 1